import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  linkTo?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  linkTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <i className="ri-search-eye-line text-3xl" />
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      )}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onAction && actionLabel && (
          <button
            type="button"
            onClick={onAction}
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            {actionLabel}
          </button>
        )}
        {linkTo && (
          <Link
            to={linkTo}
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:bg-secondary-100"
          >
            返回首页
          </Link>
        )}
      </div>
    </div>
  );
}